const types = {
  FETCH_COLLECTION_PER_PAGE: "FETCH_COLLECTION_PER_PAGE",
  USER_ADD: "USER_ADD",
  USERS_ADD: "USERS_ADD",
  USER_DELETE: "USER_DELETE",
  USER_EDIT: "USER_EDIT",
  USER_LIST_PAGINATE: "USER_LIST_PAGINATE",
  USER_LIST_RESET: "USER_LIST_RESET",
  USER_REMOVE_NEW_TAG: "USER_REMOVE_NEW_TAG",

  GROUP_ADD: "GROUP_ADD",
  GROUP_ADD_MEMBER: "GROUP_ADD_MEMBER",
  GROUP_DELETE: "GROUP_DELETE",
  GROUP_DELETE_MEMBER: "GROUP_DELETE_MEMBER",
  GROUP_EDIT: "GROUP_EDIT",
  GROUP_LIST_PAGINATE: "GROUP_LIST_PAGINATE",
  GROUP_LIST_RESET: "GROUP_LIST_RESET",
  UPDATE_DATE_RANGE: "UPDATE_DATE_RANGE",
  FETCH_PRODUCTS: "FETCH_PRODUCTS",
  EVENT_LIST_PAGINATE: "EVENT_LIST_PAGINATE",
  EVENT_LIST_RESET: "EVENT_LIST_RESET",

  USER_SET_ACTIVE: "USER_SET_ACTIVE",
  USER_SET_TAB: "USER_SET_TAB",
  SET_ACTIVE_USER: "SET_ACTIVE_USER",
  HISTORY_ACTIVE_USER: "HISTORY_ACTIVE_USER",
  SET_SETTINGS_LOADER: "SET_SETTINGS_LOADER",

  FETCH_LOCATION_PAGINATE: "FETCH_LOCATION_PAGINATE",
  LOCATION_LIST_RESET: "LOCATION_LIST_RESET",
  FETCH_CATEGORY_PAGINATE: "FETCH_CATEGORY_PAGINATE",
  CATEGORY_LIST_RESET: "CATEGORY_LIST_RESET",
  FETCH_SCHEDULE_PAGINATE: "FETCH_SCHEDULE_PAGINATE",
  SET_SCHEDULE_NEW: "SET_SCHEDULE_NEW",
  SCHEDULE_LIST_RESET: "SCHEDULE_LIST_RESET",
  SET_PAYMENT_METHOD: "SET_PAYMENT_METHOD",

  GET_TOTAL_BOOKINGS_TODAY: "GET_TOTAL_BOOKINGS_TODAY",
  SET_TOTAL_BOOKINGS_TODAY: "SET_TOTAL_BOOKINGS_TODAY"
};

export default types;
